(() => {
  if (customElements.get('fp-premium-footer')) return;

  class FPPremiumFooter extends HTMLElement {
    constructor() {
      super();
      this.returnFocus = new WeakMap();
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.querySelectorAll('[data-fp-dialog-open]').forEach((button) => {
        button.addEventListener('click', () => this.openDialog(button));
      });

      this.querySelectorAll('.fp-footer__dialog').forEach((dialog) => {
        dialog.querySelectorAll('[data-fp-dialog-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeDialog(dialog));
        });

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) this.closeDialog(dialog);
        });

        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeDialog(dialog);
        });

        dialog.addEventListener('close', () => this.afterDialogClose(dialog));
      });

      const successMessage = this.querySelector('[data-fp-newsletter-success]');
      if (successMessage) successMessage.focus({ preventScroll: true });
    }

    openDialog(button) {
      const dialogId = button.getAttribute('data-fp-dialog-open');
      const dialog = document.getElementById(dialogId);
      if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;

      this.returnFocus.set(dialog, button);
      document.body.classList.add('fp-footer-dialog-open');
      dialog.showModal();

      requestAnimationFrame(() => {
        const closeButton = dialog.querySelector('[data-fp-dialog-close]');
        if (closeButton) closeButton.focus();
      });
    }

    closeDialog(dialog) {
      if (dialog && dialog.open) dialog.close();
    }

    afterDialogClose(dialog) {
      const anyOpen = document.querySelector('.fp-footer__dialog[open]');
      if (!anyOpen) document.body.classList.remove('fp-footer-dialog-open');

      const trigger = this.returnFocus.get(dialog);
      if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
      this.returnFocus.delete(dialog);
    }
  }

  customElements.define('fp-premium-footer', FPPremiumFooter);
})();
